/* Component rendered on the MoodboardsPage to display the 
   cover info for each Moodboard
 * When clicked on it opens that Moodboard's MoodboardPage
 * The word moodshot is used through the app in the urls for moodboard */
import React, { useEffect, useState } from "react"
import { Card } from "react-bootstrap"
import { useHistory } from "react-router-dom"
import { Link } from "react-router-dom"
import { axiosInstance, axiosReq } from "../../api/axiosDefaults"
import styles from "../../styles/Moodboards.module.css"
import Col from "react-bootstrap/Col"
import Row from "react-bootstrap/Row"
import { PostDropdown } from "../../components/PostDropdown"
import mo2a from "../../assets/mo2a.png";
import { useCurrentUser } from "../../contexts/CurrentUserContext"
import { CLIENT_PROGRAM_HOSTNAME } from "../../utils/config"
import useHostName from "../../hooks/useHostName"
import toast from "react-hot-toast"

const MoodboardTop = (props) => {
  const host = useHostName()
  const {
    id,
    // is_owner,
    updated_at,
    name,
    profile_id,
    number,
    title,
    character,
    location,
  } = props
  const currentUser = useCurrentUser()
  const history = useHistory()
  const [showActionMenu, setShowActionMenu] = useState(true);
  // console.log(profile_id)

  const handleEdit = () => {
    history.push(`/${localStorage.getItem("projectSlug")}/moodshots/${id}/edit`)
  }

  const handleDelete = async () => {
    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        await axiosReq.delete(`/moodshots/${id}/`)
        toast.success(`Moodboard Deleted`);
        history.push(`/${localStorage.getItem("projectSlug")}/moodshots/`)
      } else {
        await axiosInstance.delete(
          `${localStorage.getItem("projectSlug")}/moodshots/${id}/`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        )
        toast.success(`Moodboard Deleted Successfully!`);
        history.push(`/${localStorage.getItem("projectSlug")}/moodshots/`)
      }
    } catch (err) {}
  }

  useEffect(() => {
      if (
        currentUser &&
        currentUser?.groups.length > 0 &&
        (currentUser?.groups[0]?.name === "Admincreative" ||
          currentUser?.groups[0]?.name === "Crew")
      ) {
        // now check where the post is His own post or NOT
        if (Number(profile_id) !== Number(currentUser?.profile_id)) {
          setShowActionMenu(false);
        }
      } else {
        if (
          currentUser &&
          currentUser?.groups.length > 0 &&
          currentUser?.groups[0]?.name === "Cast"
        ) {
          // Never show the menu
          setShowActionMenu(false);
        }
      }
    }, [profile_id, currentUser]);

  return (
    <div>
    <Card className={`py-0 mt-1 mb-0 ${styles.MoodCard }`}>
    <Link to={`/${localStorage.getItem("projectSlug")}/moodshots/${id}`}>
    <Card.Header className={`py-0 px-0 ${styles.MoodTop}`}>
    <Row className={`py-1 my-0 ${styles.MoodTopRow} text-center`}>
         <Col xs={12} className={`py-0 d-flex align-items-center justify-content-center ${styles.DivO} px-3`} >
        {title && <h5 className={`${styles.Bold }`}
        style={{ fontStyle: 'italic' }}> {title}</h5>}
        </Col>
    </Row> 
    </Card.Header>  
    <Card.Body className={`py-0 ${styles.White }`}
    style={{
            backgroundImage: `url(${mo2a})`,
            objectFit: "contain",
            width: "auto",
            height: "100px",
            repeat: "no-repeat",
          }} >
    <Row >
    <Col className='px-0 mx-0 text-center' xs={12}>
    <div className={` px-1 pt-3`}>
    {number && <p style={{textTransform: "capitalize" }} 
    className={`${styles.Title } mb-0 pb-0 py-auto`}>Scene {number} </p>}
    <p style={{textTransform: "capitalize" }} 
    className={`${styles.Title } mb-0 pb-0 py-auto`}> {location}</p>
    <p style={{textTransform: "capitalize" }} 
    className={`${styles.Title } mb-0 pb-0 py-auto`}>{character} </p>
    {!number && !location && !character &&
    <p style={{ fontStyle: 'italic' }}
    className={`${styles.Title } mb-0 pb-0 py-auto`}>Title Only Moodboard</p>}  
    </div>
    </Col>
    </Row>
    </Card.Body>
    {/* date */}
    <Card.Body className={`${styles.Datetext } px-0 py-0 mx-0 my-0`}>
    <Row className={`px-3 d-flex align-items-center`}>     
    <Col xs={5} className='px-0'>
    <p className={`${styles.Date2} pl-2`}>
    {name}
    </p>
    </Col>       
    <Col xs={2} className={`${styles.Icon } text-center px-0 `} >
            {/* mine  */}
        {showActionMenu && (
        <PostDropdown
            handleEdit={handleEdit}
            handleDelete={handleDelete}
        />
        ) } 
    </Col>
    <Col className="px-0" xs={5} >
    <p className={`float-right pr-2 ${styles.Date2}`}>{updated_at}</p>
    </Col>
    </Row>  
    </Card.Body>
    </Link>
    </Card> 
    </div>
  )
}

export default MoodboardTop
